import type { InfosecStorageUnit } from '../../pages/computers-page/infosec-procedure/infosecStorageUnit';
import { applications, computerTypeOptions } from '../../pages/computers-page/infosec-procedure/defaults';

function removePrefix(str: string, prefix: string): string {
  return str.startsWith(prefix) ? str.slice(prefix.length) : str;
}

export function dataItemName(
  dataItem,
  computers: InfosecStorageUnit[],
  assets: {
    number: string;
    name: string;
    uuid: string;
  }[],
  locations: InfosecStorageUnit[],
) {
  if (dataItem.application) {
    const apps = applications[dataItem.category];
    if (apps) {
      const application = apps.filter((app) => app.value === dataItem.application);
      if (application?.length) {
        return application[0].text;
      }
    } else {
      return removePrefix(dataItem.application, 'CUSTOM-') + ' ' + (dataItem.category ?? '');
    }
  } else {
    if (dataItem.category === 'computers' || dataItem.category === 'assets' || dataItem.category === 'locations') {
      const m = { assets: assets, locations: locations, computers: computers };
      const storageUnits = m[dataItem.category];
      const units = storageUnits.filter((unit: { uuid: any }) => {
        return unit.uuid === dataItem.storageUnit;
      });
      if (units.length) {
        if (dataItem.category === 'computers' && units[0].name === '') {
          return computerTypeOptions.filter((item) => item.value === units[0].computerType)[0].text;
        }
        return units[0].name;
      }
      return dataItem.name;
    }
    return dataItem.name;
  }
  return 'ukjent';
}
